import styled from "styled-components";
import { MainBlock, MainBodyTextColumn, MainFindOutMore, MainFindOutMoreColumn, MainHeadingColumn, MainImage, MainSection } from "../../../components/01_config/MainStyles";
import { sizes } from "../../../components/01_config/Sizes";

const FirstThreeSection = styled(MainSection)`
    background-color: lightgrey;
    @media(max-width: 800px) {
        flex-direction: column;
    }
`

const ColumnWrapper = styled(MainBlock)`
    background-color: white;
    padding: ${sizes.columns_padding_desk};
    justify-content: left;
`

const ColumnHeader = styled(MainHeadingColumn)`

`

const ColumnBodyText = styled(MainBodyTextColumn)`
    white-space: pre-line;
`

const ColumnImage = styled(MainImage)`
    margin-bottom: 10px;
    height: 200px;
    object-fit: cover;
`

const LearnMore = styled(MainFindOutMoreColumn)`

`

export { FirstThreeSection, ColumnWrapper, ColumnHeader, ColumnBodyText, ColumnImage, LearnMore }